export enum INVESTOR_ACCOUNT_TYPE {
  PERSONAL = 'personal',
  COMPANY = 'company',
}
